interface ReadModalProps {
  open: boolean;
  chapterTitle: string;
  onClose: () => void;
}

export default function ReadModal({ open, chapterTitle, onClose }: ReadModalProps) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-foreground-950/60" onClick={onClose}></div>
      <div className="relative z-10 w-full max-w-md rounded-xl bg-background-50 border border-background-200 p-6 text-center animate-fade-up">
        <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-700">
          <i className="ri-book-read-line text-3xl"></i>
        </div>
        <h3 className="mt-4 font-heading font-bold text-xl text-foreground-950">在线阅读功能演示中</h3>
        <p className="mt-2 text-sm text-foreground-600">
          你点击的是「{chapterTitle}」。章节阅读页仍在开发中，当前为演示范围，敬请期待正式上线。
        </p>
        <button
          type="button"
          onClick={onClose}
          className="mt-5 inline-flex w-full items-center justify-center h-11 rounded-md bg-primary-500 text-background-50 text-sm font-label font-medium hover:bg-primary-600 transition-colors cursor-pointer"
        >
          我知道了
        </button>
      </div>
    </div>
  );
}